export default "__VITE_ASSET__8f2ca31a__"